import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import { FilterOutlined } from "@ant-design/icons";
import { DatePicker as AntdDatePicker, Row, Select, Space } from "antd";
import { Button } from "components/elements";
import MyTeamWorkingInformationTable from "components/table/MyTeamWorkingInformationTable";

function MyTeamWorkingInformation({
  isLoading = false,
  selectedMode = null,
  workingInformationList = [],
  onFilter = () => {},
  onExport = () => {},
  onModeChange = () => {},
  onEndDateChange = () => {},
  onStartDateChange = () => {},
}) {
  const { t } = useTranslation();

  return (
    <Space style={{ width: "100%" }} size={24} direction="vertical">
      <Row justify="space-between">
        <Space size={12}>
          <Select
            value={selectedMode}
            defaultValue={selectedMode}
            onChange={onModeChange}
            style={{ width: 120 }}
            options={[
              {
                label: t("unit.week"),
                value: "week",
              },
              {
                label: t("unit.month"),
                value: "month",
              },
            ]}
            size="large"
          />
          <AntdDatePicker
            defaultValue={dayjs()}
            onChange={onStartDateChange}
            size="large"
          />
          <span>-</span>
          <AntdDatePicker
            defaultValue={dayjs()}
            onChange={onEndDateChange}
            size="large"
          />
        </Space>
        <Space size={12}>
          <Button type="default" onClick={onFilter}>
            {t("common.filter")} <FilterOutlined />
          </Button>
          <Button onClick={onExport}>{t("common.export")}</Button>
        </Space>
      </Row>
      <MyTeamWorkingInformationTable
        isLoading={isLoading}
        dataSource={workingInformationList}
      />
    </Space>
  );
}

export default MyTeamWorkingInformation;
